import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hyperscene-default-page',
  templateUrl: './default-page.component.html',
  styleUrls: ['./default-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DefaultPageComponent {}
